import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareMinus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-minus, remove, delete"} maskId="square-filled-radius-0-stroke-1-IconSquareMinus"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM8.00735 11.5V12.5H15.9926V11.5H8.00735Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareMinus;
